
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from './controlador';
    import _ from 'lodash';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import { Wait } from '@/__env/ext';
import { Publicacion } from '@/__env/lib/MercadoLibre/Publicaciones';

    @Component( {
        name: "Componente",
        props: {},
        components: {}
    } )
    export default class Componente extends Vue
    {

        @Prop()
        public Controlador: ControladorSeccion;
        public get Buscador() { return this.Controlador.Buscador; }
        public get Seleccionados() { return this.Controlador.Seleccionados; }


        public get Estado() { return this.Controlador.Buscador.Estado; }



        Cerrar()
        {
            this.Seleccionados.clear();
        }

        public Cargando: boolean = false;
        public get Ok(): boolean
        {
            return this.Seleccionados.length > 0;
        }

        public async Ejecutar()
        {

            this.Cargando = true;
            Utiles.GenerandoArchivo( true );
            let pdf = await Publicacion.URLListado( null, this.Seleccionados.map( x => x.Id ) );
            if ( pdf )
            {
                window.open( pdf );
            } else
            {
                Utiles.Notificaciones.Error( `Error al generar el listado` );

            }
            Utiles.GenerandoArchivo( false );
            this.Cargando = false;
        }

    }
